module.exports = __webpack_public_path__ + "img/added.8b9d658a.svg";